module.exports = __webpack_public_path__ + "com_index_06bg.jpg?73767ac1207ee26fdd008fe4b774ec9e";


//////////////////
// WEBPACK FOOTER
// ./static/images/com_index_06bg.jpg
// module id = 310
// module chunks = 0